













































































import Loading from 'vue-loading-overlay';
import { JourneysService } from '../../journeys/api/JourneysService';
import { Component, Prop, Vue, Emit, Watch, Mixins } from 'vue-property-decorator';
import { JourneysSummaryDataResponse } from '../../journeys/models/JourneysSummary';
import { FilterDateEvent } from '../../core/utils/types';
import { TypeFilterDate } from '../../core/models/type-filter-date';
import Axios from 'axios';
import {
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';

@Component({
    components: { Loading }
})
export default class JourneysPreview extends Mixins(
    StoreHelper,
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    NotificationStoreHelper,
    AuthStoreHelper
) {
    @Prop() filterDate: FilterDateEvent;
    summary: object = {
        amount: 1,
        errors: 1,
        warnings: 2,
        indicators: [{ name: 'Indicador 1', value: 200, unit: 'Km/h' }, { name: 'Indicador 2', value: 11, unit: 'h' }]
    };
    pendingRequest: boolean = false;
    cancelToken: any = null;
    summaryDataResponse: object = {
        open: 0,
        total_journeys: 0,
        unprocessed: 0,
        unprocessed_error: 0,
        unprocessed_warning: {
            generic_tag: 0,
            max_journey_duration: 61,
            max_stop_duration: 1,
            min_driver_rest_duration: 48,
            total_journeys_with_alert: 110
        }
    };
    // summary: JourneysSummaryDataResponse | null = null;
    @Emit() handleRoute() {}

    get shouldReadJourneys(): boolean {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.JOURNEYS, PRIVILEGE_TYPES.READ);
    }

    mounted() {}

    seeJourneys() {
        // this.$router.push({
        //     path: '/journeys/' + "?ids=asfasfs,asfsa"
        // })
    }

    @Watch('$route', { immediate: true, deep: true })
    @Watch('$_getSelectedCompany')
    getSummary() {
        if (this.$store.getters.getSelectedCompanyById !== null) {
            this.pendingRequest = true;
            this.cancelToken = Axios.CancelToken.source();
            JourneysService.getCompanySummaryDataResponse(
                this.$store.getters.getSelectedCompanyById,
                false,
                this.cancelToken
            )
                .then(response => {
                    this.summaryDataResponse = response.journey_summary;
                    this.pendingRequest = false;
                })
                .catch(error => {});
        }
    }

    @Emit() goToSettings() {}
}
